export default __webpack_public_path__ + "static/media/partners-banner.3c31ea94.png";